import { useDispatch } from 'react-redux';
import useTranslations from '~/components/translation/use-translations';
import { useCallback, useState } from 'react';
import Loading from '~/components/misc/loading';
import { Modal } from '~/components/modal/modal-old';
import BinaryQuestion from '~/components/binary-question';
import { spectatorUnregister } from '../../ducks/we-spin-duck';
import { WE_SPIN_MODALS_TEXT_KEYS } from '../../constants/we-spin-text-keys';

/**
 * Modal for confirming a buy-in refund (unregistering from a WeSpin stream).
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.openBuyinRefund - Whether the refund modal should be shown.
 * @param {Function} props.closeBuyinRefund - Function to close the refund modal.
 * @param {string} props.streamRef - Unique stream reference ID.
 * @param {boolean} props.isFreeWespin - Whether the event is a free WeSpin event.
 * @returns {JSX.Element}
 */
const BuyinRefundModal = props => {
	const dispatch = useDispatch();
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_MODALS_TEXT_KEYS);
	const [submitting, setSubmitting] = useState(false);

	const doUnregister = useCallback(async () => {
		try {
			setSubmitting(true);
			await dispatch(spectatorUnregister(props.streamRef));
			props.closeBuyinRefund();
		} finally {
			setSubmitting(false);
		}
	}, [dispatch, props]);

	if (isLoadingTranslations) return <Loading />;

	return (
		<Modal show={props.openBuyinRefund} position="fixed">
			<BinaryQuestion
				shouldOpenBinary
				renderInParent
				buttonsHasUncontrolledLoading={submitting}
				title={!props.isFreeWespin ? tr.WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_TITLE : 'Unregister'}
				yesText={tr.WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_YES_BUTTON}
				onYesClick={doUnregister}
				noText={tr.WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_NO_BUTTON}
				onNoClick={props.closeBuyinRefund}
			>
				<p>
					{!props.isFreeWespin
						? tr.WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_TEXT
						: 'Are you sure you want to leave this event?'}
				</p>
			</BinaryQuestion>
		</Modal>
	);
};

export default BuyinRefundModal;
